import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import WOW from 'wowjs';

import './HowItWorks.css';

import image1 from '../../../assets/images/Uno.png';
import image2 from '../../../assets/images/Dos.png';
import image3 from '../../../assets/images/Tres.png';


class HowItWorks extends Component {

  componentDidMount() {
    new WOW.WOW().init();
  }

  render() {
    return (
      <ScrollableAnchor id={'how-it-works'}>
      <section className="how-it-works">
        <div className="common-StripeGrid">
          <div className="backgroundContainer">
            <div className="grid">
              <div className="background"></div>
            </div>
          </div>
        </div>
        <div className="row step step1 container-lg">
          <div className="circle">
            <span>1</span>
          </div>
          <div className="wow fadeInLeft col col-12 col-sm-6">
            <img src={image1} alt="Usaproductos" />
          </div>
          <div className="wow fadeInUp border-left col col-12 col-sm-6 text">
            <h2>Comprá</h2>
            <div className="text">
              En Amazon, Ebay, Wallmart, Aliexpress o en cualquier tienda del mundo con tu tarjeta de crédito.
            </div>
          </div>
        </div>
        <div className="row step step2 container-lg">
          <div className="circle">
            <span>2</span>
          </div>
          <div className="wow fadeInUp col col-12 col-sm-6 border-right">
            <h2>Envía</h2>
            <div className="text">
              A nuestros depósitos en USA equipados con la más alta tecnología y seguridad.
            </div>
          </div>
          <div className="wow fadeInRight col col-12 col-sm-6">
            <img src={image2} alt="Usaproductos" />
          </div>
        </div>
        <div className="row step step3 container-lg">
          <div className="circle">
            <span>3</span>
          </div>
          <div className="wow fadeInLeft col col-12 col-sm-6">
            <img src={image3} alt="Usaproductos" />
          </div>
          <div className="wow fadeInUp col col-12 col-sm-6 border-left">
            <h2>Recibí</h2>
            <div className="text">
              En Buenos Aires y Argentina. Rápido, fácil, seguro y sin trámites.
            </div>
          </div>
        </div>
      </section>
      </ScrollableAnchor>
    )
  }
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/Home/HowItWorks/HowItWorks.js